"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const form_field_1 = require("@App/forms/v2/common/form-field");
const FormFieldFromProps_1 = __importDefault(require("@App/kit/fields/v2/FormFieldFromProps"));
const InnerForm = ({ formFields, fieldValidationDependencies }) => {
    const fieldHasValidationDependency = (formField) => {
        var _a;
        return (_a = fieldValidationDependencies === null || fieldValidationDependencies === void 0 ? void 0 : fieldValidationDependencies.find((dep) => dep.dependOn.name === formField.name)) === null || _a === void 0 ? void 0 : _a.dependencies;
    };
    return (react_1.default.createElement(react_1.default.Fragment, null, (0, form_field_1.isFormFields)(formFields) &&
        Object.values(formFields).map((formField) => {
            if ((0, form_field_1.isFormFieldProp)(formField)) {
                const foundDependencies = fieldHasValidationDependency(formField);
                if (foundDependencies && foundDependencies.length > 0) {
                    return (react_1.default.createElement(FormFieldFromProps_1.default, { field: formField, key: formField.name, validationDependency: foundDependencies }));
                }
                else {
                    return react_1.default.createElement(FormFieldFromProps_1.default, { field: formField, key: formField.name });
                }
            }
            else {
                return react_1.default.createElement(react_1.default.Fragment, null);
            }
        })));
};
exports.default = InnerForm;
